/* eslint-disable react/prop-types */
import React from 'react';
import { Paper, Typography, Box } from '@mui/material';

export default function PaymentInvoice({ bundle }) {
  return (
    <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: '600', color: '#007d7d' }}>
        Your Bill Info
      </Typography>

      <Box component="table" sx={{ width: '100%', borderCollapse: 'collapse' }}>
        <Box component="thead" sx={{ bgcolor: '#f1f1f1' }}>
          <Box component="tr">
            <Box component="th" sx={{ textAlign: 'left', p: 1, fontWeight: '600' }}>Description</Box>
            <Box component="th" sx={{ textAlign: 'center', p: 1, fontWeight: '600' }}>Value</Box>
            <Box component="th" sx={{ textAlign: 'right', p: 1, fontWeight: '600' }}>Price</Box>
          </Box>
        </Box>

        <Box component="tbody">
          <Box component="tr">
            <Box component="td" sx={{ p: 1 }}>{bundle.description}</Box>
            <Box component="td" sx={{ textAlign: 'center', p: 1 }}>{bundle.coins} Coin</Box>
            <Box component="td" sx={{ textAlign: 'right', p: 1 }}>{bundle.price} USD</Box>
          </Box>
        </Box>

        <Box component="tfoot">
          <Box component="tr">
            <Box component="td" sx={{ p: 1, fontWeight: '600' }}>Tax</Box>
            <Box component="td" sx={{ textAlign: 'center', p: 1 }}>0%</Box>
            <Box component="td" sx={{ textAlign: 'right', p: 1 }}>0 USD</Box>
          </Box>
          <Box component="tr">
            <Box component="td" sx={{ p: 1, fontWeight: '600' }}>Total</Box>
            <Box component="td" sx={{ textAlign: 'center', p: 1 }}> </Box>
            <Box component="td" sx={{ textAlign: 'right', p: 1, fontWeight: '600', color: '#007d7d' }}>
              {bundle.price} USD
            </Box>
          </Box>
        </Box>
      </Box>

      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        You will pay the equivalent value in EGP.
      </Typography>
    </Paper>
  );
}
